import { template } from 'lodash';

import * as Images from './Images';

const symbols = {
  configs: Symbol('Configs instance property'),
  templateOptions: Symbol('Template options property'),
};

export default class Utils {

  /**
   * mustache.js style template
   *
   * @type {{evaluate: RegExp, interpolate: RegExp, escape: RegExp}}
   */
  [symbols.templateOptions] = {
    evaluate: /\{\{#([\s\S]+?)\}\}/g, // {{# console.log("test") }}
    interpolate: /[{]{2}([^#{].+?)[}]{2}/g, // {{ data }}
    escape: /\{\{\{([\s\S]+?)\}\}\}/g, // {{{ title }}}
    variable: 'data',
    imports: {},
  };

  constructor(configsInstance, i18nInstance) {
    this[symbols.configs] = configsInstance;
    this[symbols.templateOptions].imports = {
      t: ::i18nInstance.translate,
    };
  }

  async init() {
    return this;
  }

  /**
   * include image utilities
   */
  Images = Images;

  formatStoreName(data = {}) {
    const format = this[symbols.configs].get('tulip.storeNameTemplate', '');

    return template(format, this[symbols.templateOptions])(data).trim();
  }

  formatAssociateName(data = {}) {
    const format = this[symbols.configs].get('tulip.associateNameTemplate', '');

    return template(format, this[symbols.templateOptions])(data).trim();
  }

  formatCustomerName(data = {}) {
    const format = this[symbols.configs].get('tulip.customerNameTemplate', '');

    return template(format, this[symbols.templateOptions])(data).trim();
  }
}



// WEBPACK FOOTER //
// ./src/Utils/Utils.js